// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"8de9a59a","783":"4309e705","787":"8fedd6c6"}[chunkId] + ".chunk.js";
};